// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__VSLIG","subHeading":"styles_subHeading__itFux","videoSection":"styles_videoSection__WhFMY"};